import React from 'react'
import { PropTypes } from 'prop-types'
import { Toggle } from 'components/common/toggle'
import classNames from 'classnames/bind'
import styles from './HowToUpdatePrice.module.scss'
import { Info } from 'components/common/info'
import { useTranslation } from 'react-i18next'

const cx = classNames.bind(styles)

const HowToUpdatePrice = ({ priceChangeMethod, onPriceChangeMethodToggle, supportsPriceExecution }) => {
  const { t } = useTranslation(['translations'])

  const { sendToPos, notifyStationManager } = priceChangeMethod

  return (
    <div className={cx('how-to-update-price')}>
      <div className={cx('title')}>
        <span>{t('widgets.competitorPricing.priceChangesTypeTitle')}</span>
        <Info
          tooltipText={[
            <strong>{t('widgets.competitorPricing.priceChangesTypeSendToPos')}</strong>,
            t('widgets.competitorPricing.priceChangesTypeSendToPosExplainer'),
            <strong>{t('widgets.competitorPricing.priceChangesTypeNotifyStationManager')}</strong>,
            t('widgets.competitorPricing.priceChangesTypeNotifyStationManagerExplainer'),
          ]}
        />
      </div>

      <div className={cx('toggles')}>
        <Toggle
          id="update-on-pos-toggle"
          label="Send to POS"
          checked={sendToPos}
          handleToggle={() => onPriceChangeMethodToggle('sendToPos')}
          disabled={!supportsPriceExecution}
          tooltipText={
            !supportsPriceExecution
              ? t('widgets.competitorPricing.priceChangesTypeSendToPosUnsupported')
              : null
          }
        />
        <Toggle
          id="notify-station-manager-toggle"
          label="Notify station manager"
          checked={notifyStationManager}
          handleToggle={() => onPriceChangeMethodToggle('notifyStationManager')}
        />
      </div>
    </div>
  )
}

HowToUpdatePrice.propTypes = {
  priceChangeMethod: PropTypes.shape({
    sendToPos: PropTypes.bool.isRequired,
    notifyStationManager: PropTypes.bool.isRequired,
  }).isRequired,
  onPriceChangeMethodToggle: PropTypes.func.isRequired,
}

export { HowToUpdatePrice }
